import { useSessionContext } from '@/_providers/session-provider'

export const useSession = () => {
  return useSessionContext()
}
